import { useQuery } from '@tanstack/react-query';

import { getCheckWithYouApplyLink, getCheckWithYouDetail, getCheckWithYouOrderHistory } from './service';

export const useGetCheckWithYouOrderHistory = (enabled = true) => {
  return useQuery({
    queryKey: ['checkWithYouOrderHistory'],

    queryFn: getCheckWithYouOrderHistory,
    enabled,
  });
};

export const useGetCheckWithYouDetail = (checkWithYouId: number | string) => {
  return useQuery({
    queryKey: ['checkWithYouDetail', checkWithYouId],

    queryFn: () => getCheckWithYouDetail(checkWithYouId),
    enabled: !!checkWithYouId,
  });
};

/**
 * 신청 폼 링크. 토큰 유효기간이 7일이라 화면을 여는 시점에 받아두면 충분하고,
 * 그래야 버튼을 눌렀을 때 새 탭이 팝업 차단에 걸리지 않는다(비동기 후 window.open 은 막힌다).
 * 기본은 비활성 — 신청 버튼을 실제로 보여주는 화면에서만 켠다.
 */
export const useGetCheckWithYouApplyLink = (enabled = false) => {
  return useQuery({
    queryKey: ['checkWithYouApplyLink'],

    queryFn: getCheckWithYouApplyLink,
    enabled,
    gcTime: 0,
  });
};
